import { combineReducers } from '@reduxjs/toolkit'
import { todosReducer } from '../modules/todos/store'

const reducers = combineReducers({
  todos: todosReducer,
})

export default reducers
